import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exclamation from '../../../assets/images/icons/icon-exclamation-circle.svg';
import googleSignIn from '../../../assets/images/google-sign-up-logo.svg';
import msSignIn from '../../../assets/images/ms-sign-up-logo.svg';
import StyledTextField from '../common/StyledTextField';
import PasswordInput from '../PasswordInput';

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      company: props.company || '',
      termsAccepted: false,
      userName: props.userName || '',
      errors: {},
      submitted: false,
      showPasswordField: false,
    };
    this.togglePasswordField = this.togglePasswordField.bind(this);
  }

  togglePasswordField(e) {
    const { showPasswordField } = this.state;
    e.preventDefault();

    this.setState({ showPasswordField: !showPasswordField });
  }

  render() {
    const {
      error,
      csrfToken,
      passwordError,
      email,
      submitUrl,
      signUpUrl,
      googleOmniauthUrl,
      msOmniauthUrl,
      forgotPasswordUrl,
      recommendationIds,
      appliedToProject,
      sourced,
      conResourceId,
      request,
      location,
    } = this.props;
    const { showPasswordField } = this.state;

    return (
      <div className="style-guide card sign-in mx-auto">
        <h1 className="hero-header text-center">Welcome back!</h1>
        { error
          && (
          <div className="sign-in-alert body-text-2 text-center">
            <img src={exclamation} className="me-2" alt="error" />
            { error }
          </div>
          )}
        <form id="new_user" action={submitUrl} method="post" acceptCharset="UTF-8">
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <input type="hidden" name="recommendation_ids" value={recommendationIds} />
          <input type="hidden" name="user[applied_to_project]" value={appliedToProject} />
          <input type="hidden" name="user[sourced]" value={sourced} />
          <input type="hidden" name="user[con_resource_id]" value={conResourceId} />
          <input type="hidden" name="user[request]" value={request} />
          <StyledTextField
            id="email"
            className="form-control fs-hide work-email"
            name="user[email]"
            label="Email"
            type="email"
            defaultValue={email}
            required
            autoFocus
          />
          { showPasswordField
            && (
            <PasswordInput
              errors={passwordError}
              title="Password"
              type="created"
            />
            )}
          <div className="actions">
            { showPasswordField
              ? <button type="submit" className="btn btn-primary bigger-button full-width">Log in</button>
              : (
                <button
                  className="btn btn-primary bigger-button full-width"
                  onClick={this.togglePasswordField}
                >
                  Continue with Email
                </button>
              )}
          </div>
          { showPasswordField
            && (
            <div className="body-text-2 medium-text text-center forgot-password">
              <a href={forgotPasswordUrl}>Forgot your password?</a>
            </div>
            )}
        </form>
        { !showPasswordField && (googleOmniauthUrl || msOmniauthUrl) && [
          <div className="sign-in-divider my-3">
            <hr />
            <div className="or-text">or</div>
            <hr />
          </div>,
          <div className="sign-in-provider">
            { googleOmniauthUrl
              && (
              <a href={`${googleOmniauthUrl}?prompt=select_account&state=sign-in`} className="google-sign-in">
                <img src={googleSignIn} alt="Sign in with Google" />
                <div className="sign-in-text">
                  Sign in with Google
                </div>
              </a>
              )}
            { msOmniauthUrl
              && (
              <a href={`${msOmniauthUrl}?state=sign-in`} className="ms-sign-in">
                <img src={msSignIn} alt="Sign in with Microsoft" />
                <div className="sign-in-text">
                  Sign in with Microsoft
                </div>
              </a>
              )}
          </div>,
        ]}

        <div className="body-text-2 medium-weight text-center register-link">
          Don&#39;t have a Clora account?&nbsp;&nbsp;
          <a className={`employer-registration-to-log-in-${location}`} href={signUpUrl}>Sign Up</a>
        </div>
      </div>
    );
  }
}

SignIn.propTypes = {
  userName: PropTypes.string,
  error: PropTypes.string,
  passwordError: PropTypes.string,
  email: PropTypes.string,
  submitUrl: PropTypes.string.isRequired,
  signUpUrl: PropTypes.string.isRequired,
  forgotPasswordUrl: PropTypes.string.isRequired,
  recommendationIds: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  company: PropTypes.string,
  location: PropTypes.string,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  appliedToProject: PropTypes.string,
  sourced: PropTypes.string,
  conResourceId: PropTypes.string,
  request: PropTypes.string,
};

SignIn.defaultProps = {
  userName: '',
  email: null,
  error: null,
  passwordError: null,
  company: null,
  location: 'sign-in',
  recommendationIds: null,
  appliedToProject: null,
  sourced: null,
  conResourceId: null,
  request: null,
};

export default SignIn;
